import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-lg-6 mt-4 mt-lg-0 px-2"
}
const _hoisted_2 = { class: "card bg-light" }
const _hoisted_3 = { class: "card-body p-3" }
const _hoisted_4 = { class: "row mx-n2" }
const _hoisted_5 = { class: "col-lg-6 px-2" }
const _hoisted_6 = { width: "100%" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", { width: "100" }, "Nomor Meja", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", { width: "10" }, ":", -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", { width: "100" }, "Online Order", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { width: "10" }, ":", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, "Nomor Nota", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, ":", -1)
const _hoisted_15 = { class: "col-lg-6 px-2" }
const _hoisted_16 = { width: "100%" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", { width: "100" }, "Nama Bigboss", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", { width: "10" }, ":", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", null, "Pelayan Input", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", null, ":", -1)
const _hoisted_21 = {
  key: 0,
  class: "card mt-2"
}
const _hoisted_22 = {
  class: "table-responsive",
  style: {"max-height":"calc(100vh - 350px)","height":"100vh"}
}
const _hoisted_23 = { class: "table table-menu m-0" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-dark text-white" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "No"),
    /*#__PURE__*/_createElementVNode("th", null, "Nama Menu"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Qty"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Harga"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Total")
  ])
], -1)
const _hoisted_25 = {
  colspan: "7",
  class: "bg-accent text-white"
}
const _hoisted_26 = { class: "text-center" }
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = { class: "text-center" }
const _hoisted_29 = {
  key: 1,
  class: "card mt-2"
}
const _hoisted_30 = { class: "table table-menu table-condensed m-0" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", { class: "text-right" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Total")
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", {
  width: "5",
  class: "px-0"
}, [
  /*#__PURE__*/_createElementVNode("strong", null, ":")
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", { width: "10" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Rp")
], -1)
const _hoisted_34 = {
  class: "text-right text-danger",
  width: "150"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", { width: "10" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("td", { class: "text-right" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Pajak Resto")
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", { class: "px-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, ":")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Rp")
], -1)
const _hoisted_39 = {
  class: "text-right text-danger",
  width: "150"
}
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("td", { class: "text-right" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Diskon")
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("td", { class: "px-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, ":")
], -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Rp")
], -1)
const _hoisted_44 = {
  class: "text-right text-danger",
  width: "150"
}
const _hoisted_45 = { key: 1 }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("td", { class: "text-right" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Voucher")
], -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("td", { class: "px-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, ":")
], -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Rp")
], -1)
const _hoisted_49 = {
  class: "text-right text-danger",
  width: "150"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("td", { class: "text-right" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Total Bayar")
], -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("td", { class: "px-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, ":")
], -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Rp")
], -1)
const _hoisted_53 = {
  class: "text-right text-danger",
  width: "150"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("td", { class: "text-right" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Free Kembalian")
], -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("td", { class: "px-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, ":")
], -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Rp")
], -1)
const _hoisted_57 = {
  class: "text-right text-danger",
  width: "150"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("td", { class: "p-0 px-2" }, null, -1)
const _hoisted_59 = {
  key: 2,
  class: "card mt-2"
}
const _hoisted_60 = { class: "card-body p-2" }
const _hoisted_61 = { class: "row mx-n1 justify-content-center" }
const _hoisted_62 = { class: "col-auto px-1 mb-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showHistoryDetail)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("table", _hoisted_6, [
                  (_ctx.historyDetail.transaction.m_transaction_table_table_name_list != ''
                )
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                        _hoisted_8,
                        _hoisted_9,
                        _createElementVNode("td", null, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.historyDetail.transaction
                      .m_transaction_table_table_name_list), 1)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                        _hoisted_11,
                        _hoisted_12,
                        _createElementVNode("td", null, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.historyDetail.transaction.name), 1)
                        ])
                      ])),
                  _createElementVNode("tr", null, [
                    _hoisted_13,
                    _hoisted_14,
                    _createElementVNode("td", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.historyDetail.transaction
                      .m_transaction_table_note_number), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("table", _hoisted_16, [
                  _createElementVNode("tr", null, [
                    _hoisted_17,
                    _hoisted_18,
                    _createElementVNode("td", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.historyDetail.transaction
                      .m_transaction_table_customer_name), 1)
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_19,
                    _hoisted_20,
                    _createElementVNode("td", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.historyDetail.transaction.nama_kasir), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        (_ctx.historyDetail)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("table", _hoisted_23, [
                  _hoisted_24,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historyDetail.menus, (menuJenis) => {
                    return (_openBlock(), _createElementBlock("tbody", {
                      key: menuJenis.id
                    }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_25, _toDisplayString(menuJenis.name), 1)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuJenis.items, (listMenus, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: listMenus.m_transaction_menu_id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", null, _toDisplayString(listMenus.m_menu_nama), 1),
                          _createElementVNode("td", _hoisted_26, _toDisplayString(listMenus.m_transaction_menu_qty), 1),
                          _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.getPrice(listMenus.m_transaction_menu_qty, listMenus.m_transaction_menu_price)), 1),
                          _createElementVNode("td", _hoisted_28, _toDisplayString(listMenus.m_transaction_menu_price), 1)
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.historyDetail)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("table", _hoisted_30, [
                _createElementVNode("tr", null, [
                  _hoisted_31,
                  _hoisted_32,
                  _hoisted_33,
                  _createElementVNode("td", _hoisted_34, _toDisplayString(_ctx.historyDetail.transaction.nominal_pembulatan), 1),
                  _hoisted_35
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_36,
                  _hoisted_37,
                  _hoisted_38,
                  _createElementVNode("td", _hoisted_39, _toDisplayString(_ctx.historyDetail.transaction.nominal_pajak), 1)
                ]),
                (_ctx.hasDiscount)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_40, [
                      _hoisted_41,
                      _hoisted_42,
                      _hoisted_43,
                      _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.discountVal), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.hasVoucher)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_45, [
                      _hoisted_46,
                      _hoisted_47,
                      _hoisted_48,
                      _createElementVNode("td", _hoisted_49, _toDisplayString(_ctx.voucherVal), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("tr", null, [
                  _hoisted_50,
                  _hoisted_51,
                  _hoisted_52,
                  _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.historyDetail.transaction.nominal_total_bayar), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_54,
                  _hoisted_55,
                  _hoisted_56,
                  _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.historyDetail.transaction.nominal_free_kembalian), 1),
                  _hoisted_58
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.historyDetail)
          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("button", {
                      class: "btn btn-primary font-weight-bold btn-sm",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadStructFile(_ctx.historyDetail.struct_name))),
                      type: "button"
                    }, " Print Ulang ")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}